webpackJsonp([1],{

/***/ "/Vnm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/oiM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BlogNav__ = __webpack_require__("y7Eb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogFeed__ = __webpack_require__("xdpD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContactForm__ = __webpack_require__("wCbp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BlogPost__ = __webpack_require__("InHs");
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contact',
  components: { BlogNav: __WEBPACK_IMPORTED_MODULE_0__BlogNav__["a" /* default */], ContactForm: __WEBPACK_IMPORTED_MODULE_2__ContactForm__["a" /* default */], BlogFeed: __WEBPACK_IMPORTED_MODULE_1__BlogFeed__["a" /* default */], BlogPost: __WEBPACK_IMPORTED_MODULE_3__BlogPost__["a" /* default */] },
  resource: 'Contact',
  props: {
    post: String,
    author: String
  },

  data: function data() {
    return {
      navs: 0,
      title: '',
      labels: {
        post: '',
        author: ''
      }
    };
  },

  computed: {
    content: function content() {
      return { title: this.title, labels: this.labels };
    },
    filters: function filters() {
      var filters = {};

      if (this.post) filters.post = this.post;
      if (this.author) filters.author = this.author;

      return filters;
    }
  },

  watch: {
    '$route.name': function $routeName(to, from) {
      if (to !== from) this.navs++;
    }
  },

  beforeMount: function beforeMount() {
    this.$getResource('blog');
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2x06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("cX0o");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-feed',
  resource: 'BlogFeed',

  props: {
    filters: {
      type: Object,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      posts: [],
      transition: 'preview-appear'
    };
  },


  computed: {
    reading: function reading() {
      return this.filters.post;
    },
    scrollDelay: function scrollDelay() {
      return this.$device.phone ? 0 : 560;
    },
    figureClass: function figureClass() {
      return { 'preview__figure--mobile': this.$device.phone && this.reading };
    },
    feed: function feed() {
      var _this = this;

      var filterBy = {
        post: function post(filter, _ref) {
          var id = _ref.id;
          return filter === id;
        },
        author: function author(filter, _ref2) {
          var _author = _ref2.author;
          return filter === _this.kebabify(_author);
        }
      };

      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).length) return this.posts;

      return this.posts.filter(function (post) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.filters).every(function (filter) {
          return filterBy[filter](_this.filters[filter], post);
        });
      });
    }
  },

  methods: {
    scrollTo: __WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* scrollTo */],
    kebabify: __WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* kebabify */],
    prettyDate: __WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* prettyDate */],
    getBgImg: function getBgImg(src) {
      return { backgroundImage: 'url(' + src + ')' };
    },
    stackPosts: function stackPosts(posts) {
      var _this2 = this;

      var interval = void 0;
      var stack = function stack() {
        _this2.posts.push(posts.shift());

        if (!posts.length) {
          _this2.transition = 'preview';
          clearInterval(interval);
        }
      };

      interval = setInterval(stack, 125);
    }
  },

  beforeMount: function beforeMount() {
    var _this3 = this;

    this.$getResource('feed').then(function (posts) {
      if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.filters).length) {
        _this3.stackPosts(posts);
      } else {
        _this3.posts = posts;
        _this3.transition = 'preview';
      }
    });
  }
});

/***/ }),

/***/ "4VGO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"post"}},[(_vm.post)?_c('article',{staticClass:"post"},[_c('header',{staticClass:"post__header"},[_c('link',{attrs:{"rel":"stylesheet","href":"https://www.w3schools.com/w3css/4/w3.css"}}),_vm._v(" "),_c('h2',{staticClass:"post__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('blockquote',{staticClass:"post__subtitle"},[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_vm._l((_vm.content),function(item){return _c('div',{key:_vm.content.id},[(_vm.isText(item))?_c('div',{staticClass:"post__body rte w3-container",domProps:{"innerHTML":_vm._s(item)}}):(_vm.isImage(item))?_c('img',{directives:[{name:"img",rawName:"v-img:image",arg:"image"}],staticClass:"img-thumbnail",attrs:{"src":item}}):(_vm.isGallery(item))?_c('img',{directives:[{name:"img",rawName:"v-img:image",arg:"image"}],staticClass:"imgGallery-thumbnail",attrs:{"src":item}}):_vm._e()])}),_vm._v(" "),_c('section',{staticClass:"post__body"})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9k9s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Blog__ = __webpack_require__("eJ85");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Blog", function() { return __WEBPACK_IMPORTED_MODULE_0__Blog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogFeed__ = __webpack_require__("bksL");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BlogFeed", function() { return __WEBPACK_IMPORTED_MODULE_1__BlogFeed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BlogPost__ = __webpack_require__("rcwA");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BlogPost", function() { return __WEBPACK_IMPORTED_MODULE_2__BlogPost__["a"]; });




/***/ }),

/***/ "CHQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BlogNav__ = __webpack_require__("y7Eb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlogFeed__ = __webpack_require__("xdpD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BlogPost__ = __webpack_require__("InHs");
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog',
  components: { BlogNav: __WEBPACK_IMPORTED_MODULE_0__BlogNav__["a" /* default */], BlogFeed: __WEBPACK_IMPORTED_MODULE_1__BlogFeed__["a" /* default */], BlogPost: __WEBPACK_IMPORTED_MODULE_2__BlogPost__["a" /* default */] },
  resource: 'Blog',
  props: {
    post: String,
    author: String
  },

  data: function data() {
    return {
      navs: 0,
      title: '',
      labels: {
        post: '',
        author: ''
      }
    };
  },


  computed: {
    content: function content() {
      return { title: this.title, labels: this.labels };
    },
    filters: function filters() {
      var filters = {};

      if (this.post) filters.post = this.post;
      if (this.author) filters.author = this.author;

      return filters;
    }
  },

  watch: {
    '$route.name': function $routeName(to, from) {
      if (to !== from) this.navs++;
    }
  },

  beforeMount: function beforeMount() {
    this.$getResource('blog');
  }
});

/***/ }),

/***/ "Dk1v":
/***/ (function(module, exports) {

module.exports = {"_args":[["scrollto-with-animation@4.5.2","C:\\Users\\1601\\Developpements\\camera-club"]],"_from":"scrollto-with-animation@4.5.2","_id":"scrollto-with-animation@4.5.2","_inBundle":false,"_integrity":"sha1-WoS10aHtlDvlRiVULXcxk9bBGd4=","_location":"/scrollto-with-animation","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"scrollto-with-animation@4.5.2","name":"scrollto-with-animation","escapedName":"scrollto-with-animation","rawSpec":"4.5.2","saveSpec":null,"fetchSpec":"4.5.2"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/scrollto-with-animation/-/scrollto-with-animation-4.5.2.tgz","_spec":"4.5.2","_where":"C:\\Users\\1601\\Developpements\\camera-club","author":{"name":"David Sancho","email":"dsnxmoreno@gmail.com","url":"https://github.com/davesnx"},"bugs":{"url":"https://github.com/davesnx/scrollto-with-animation/issues"},"dependencies":{"animation-frame":"^0.3.0"},"description":"Animated Scroll with requestAnimationFrame. For smooth animate scrollTo defining the easing, running at 60FPS and cross-browser","devDependencies":{"babel-cli":"^6.9.0","babel-loader":"^6.2.2","babel-preset-es2015":"^6.3.13","babel-preset-stage-2":"^6.3.13","jasmine-core":"^2.3.4","json-loader":"^0.5.4","karma":"^0.13.9","karma-chrome-launcher":"^0.2.1","karma-cli":"0.1.0","karma-coverage":"^0.5.3","karma-jasmine":"^0.3.6","karma-phantomjs-launcher":"^0.2.1","karma-sourcemap-loader":"^0.3.6","karma-spec-reporter":"0.0.22","karma-story-reporter":"^0.3.1","karma-webpack":"^1.7.0","phantomjs":"^1.9.18","pre-push":"^0.1.1","webpack":"^1.12.13"},"files":["src","lib","dist","README.md"],"homepage":"https://github.com/davesnx/scrollto-with-animation#readme","keywords":["animation","scrollTo","60fps","cross-browser","requestAnimationFrame","easeInQuad","browserify"],"license":"MIT","main":"lib/index.js","name":"scrollto-with-animation","pre-commit":["test"],"repository":{"type":"git","url":"git+https://github.com/davesnx/scrollto-with-animation.git"},"scripts":{"build":"npm run clean && npm run compile:prod && npm run minify:prod","clean":"rm -rf dist/* && rm -rf lib/","compile:dev":"NODE_ENV=dev babel src --watch --out-dir lib","compile:prod":"NODE_ENV=prod babel src --out-dir lib","minify:dev":"NODE_ENV=dev webpack --watch","minify:prod":"NODE_ENV=prod webpack -p","prepublish":"npm run build","test":"NODE_ENV=prod karma start test/karma.config.js --single-run","test:dev":"NODE_ENV=prod karma start test/karma.config.js --auto-watch"},"standard":{"parser":"babel-eslint","global":["jasmine","it","describe","beforeEach","afterEach","expect","spyOn"]},"version":"4.5.2"}

/***/ }),

/***/ "E7C/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__("cX0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_img__ = __webpack_require__("Rwp6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var vueImgConfig = {
  altAsTitle: false,
  sourceButton: false,
  openOn: 'click',
  thumbnails: true
};
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_v_img__["a" /* default */], vueImgConfig);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-post',
  resource: 'BlogPost',
  props: { post: String },
  data: function data() {
    return {
      title: '',
      author: '',
      content: '',
      published: '',
      description: '',
      commentsReady: false
    };
  },


  watch: {
    post: function post(to, from) {
      this.content = '';

      if (to === from || !this.post) return;

      this.commentsReady = false;
      this.$getResource('post', to).then(this.showComments);
    }
  },

  methods: {
    kebabify: __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* kebabify */],
    prettyDate: __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* prettyDate */],
    isText: function isText(item) {
      return !item.startsWith('/static/');
    },
    isImage: function isImage(item) {
      return item.startsWith('/static/image/');
    },
    isGallery: function isGallery(item) {
      return item.startsWith('/static/imageGallery/');
    },
    showComments: function showComments() {
      var _this = this;

      setTimeout(function () {
        _this.commentsReady = true;
      }, 1000);
    },
    onLoad: function onLoad() {
      this.loading = false;
    }
  },

  updated: function updated() {
    // this.content = ''
  },
  beforeMount: function beforeMount() {
    if (!this.post) return;
    this.$getResource('post', this.post).then(this.showComments);
  }
});

/***/ }),

/***/ "Ey2R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"blog__feed",attrs:{"tag":"ul","name":_vm.transition}},_vm._l((_vm.feed),function(post){return _c('li',{key:post.id,staticClass:"preview"},[_c('figure',{staticClass:"preview__figure",class:_vm.figureClass,style:(_vm.getBgImg(post.image))},[_c('transition',{attrs:{"name":"v--fade"}},[(!_vm.reading || _vm.$device.phone)?_c('figcaption',{staticClass:"preview__details"},[_c('router-link',{staticClass:"preview__title",attrs:{"to":("/read/" + (post.id))},nativeOn:{"click":function($event){_vm.scrollTo(0, 220, _vm.scrollDelay)}}},[_vm._v("\n            "+_vm._s(post.title)+"\n          ")])],1):_vm._e()])],1)])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FnhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("/oiM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5598ff0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("vTyi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5598ff0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GXXQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "InHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__ = __webpack_require__("E7C/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_443730f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__ = __webpack_require__("4VGO");
function injectStyle (ssrContext) {
  __webpack_require__("/Vnm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_443730f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JXvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"id":"app"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KoCi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"blog",class:{ 'blog--reading': this.post }},[_c('blog-nav',{attrs:{"content":_vm.content,"filters":_vm.filters,"navs":_vm.navs}}),_vm._v(" "),_c('blog-feed',{attrs:{"filters":_vm.filters}}),_vm._v(" "),_c('blog-post',{attrs:{"post":_vm.post}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27bf8814_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("JXvG");
function injectStyle (ssrContext) {
  __webpack_require__("WwkJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27bf8814_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MdQY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return matchMedia; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);


var matchMediaFallback = function matchMediaFallback() {
  var listeners = [];
  var idle = true;

  var device = function () {
    var node = document.createElement('div');
    var style = document.createElement('style');

    node.id = 'match-media-node';
    style.innerHTML = '#match-media-node {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      bottom: 100%;\n      overflow: scroll;\n    }';

    document.head.appendChild(style);
    document.body.insertBefore(node, document.body.children[0]);

    return {
      get width() {
        return node.clientWidth;
      },
      get height() {
        return node.clientHeight;
      },
      get orientation() {
        return node.clientHeight > node.clientWidth ? 'portrait' : 'landscape';
      },
      get fontSize() {
        return window.getComputedStyle(document.documentElement).getPropertyValue('font-size');
      }
    };
  }();

  var createHandler = function createHandler(feature, value) {
    if (feature === 'orientation') {
      return function () {
        return value === device.orientation;
      };
    }

    var _feature$split$revers = feature.split('-').reverse(),
        _feature$split$revers2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_feature$split$revers, 2),
        prop = _feature$split$revers2[0],
        limit = _feature$split$revers2[1];

    var operand = !limit ? '==' : limit === 'min' ? '<' : '>';

    var parseValue = function () {
      return ~value.indexOf('em') ? function () {
        return parseFloat(value) * device.fontSize;
      } : function () {
        return parseFloat(value);
      };
    }();

    var handlers = {
      'width': function width() {
        return eval(parseValue() + operand + device.width);
      },
      'height': function height() {
        return eval(parseValue() + operand + device.height);
      }
    };

    return handlers[prop];
  };

  var parseQuery = function parseQuery(queryString) {
    var _queryString$replace$ = queryString.replace(/[()\s]/g, '').split(':'),
        _queryString$replace$2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_queryString$replace$, 2),
        feature = _queryString$replace$2[0],
        value = _queryString$replace$2[1];

    return createHandler(feature, value);
  };

  window.addEventListener('resize', function () {
    if (!idle) return;
    idle = false;

    var width = device.width;
    var height = device.height;

    var timer = setInterval(function () {
      if (width !== device.width || height !== device.height) {
        width = device.width;
        height = device.height;
      } else {
        clearTimeout(timer);
        listeners.forEach(function (handler) {
          return handler();
        });
        idle = true;
      }
    }, 100);
  });

  return function (queryString) {
    var query = parseQuery(queryString);
    var matcher = {
      get matches() {
        return query();
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, matcher, {
      addListener: function addListener(cb) {
        var handler = function handler() {
          return cb(matcher);
        };
        listeners.push(handler);
      }
    });
  };
};

var matchMedia = window.matchMedia || matchMediaFallback();



/***/ }),

/***/ "MfHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("cX0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__("8+8L");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contactform',
  resource: 'BlogFeed',

  props: {
    filters: {
      type: Object,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      transition: 'preview-appear',
      contact: {
        name: '',
        email: '',
        message: ''
      },

      isSending: false
    };
  },


  methods: {
    scrollTo: __WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* scrollTo */],
    clearForm: function clearForm() {
      for (var field in this.contact) {
        this.contact[field] = '';
      }
    },
    onSubmit: function onSubmit(evt) {
      var _this = this;

      evt.preventDefault();

      this.isSending = true;

      setTimeout(function () {
        var form = new FormData();
        for (var field in _this.contact) {
          form.append(field, _this.contact[field]);
        }
        _this.$http.post('./static/email.php', form).then(function (response) {
          _this.clearForm();
          _this.isSending = false;
        }).catch(function (e) {
          console.log(e);
        });
      }, 1000);
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startup__ = __webpack_require__("is/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources__ = __webpack_require__("9k9s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_resource__ = __webpack_require__("cb2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_device_queries__ = __webpack_require__("uJQI");









__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__plugins_resource__["a" /* default */], {
  resources: __WEBPACK_IMPORTED_MODULE_4__resources__,
  endpoint: '/static/api'
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__plugins_device_queries__["a" /* default */], {
  phone: 'max-width: 567px',
  tablet: 'min-width: 568px',
  mobile: 'max-width: 1024px',
  laptop: 'min-width: 1025px',
  desktop: 'min-width: 1280px',
  monitor: 'min-width: 1448px'
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]);
  }
}).$mount('#app');

/***/ }),

/***/ "Rwp6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
!function(){if("undefined"!=typeof document){var e=document.head||document.getElementsByTagName("head")[0],t=document.createElement("style"),n=" *[data-v-5928e1c7] { -webkit-box-sizing: border-box; box-sizing: border-box; } .fullscreen-v-img[data-v-5928e1c7] { z-index: 9999; height: 100%; width: 100%; position: fixed; top: 0; left: 0; overflow: hidden; background-color: rgba(0, 0, 0, 0.7); -ms-touch-action: none; touch-action: none; } .content-v-img img[data-v-5928e1c7] { width: auto; height: auto; max-width: 100%; max-height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } .header-v-img[data-v-5928e1c7], .footer-v-img[data-v-5928e1c7] { position: absolute; width: 100%; background-color: rgba(0, 0, 0, 0.3); height: 50px; z-index: 9999; display: flex; align-items: center; } .header-v-img[data-v-5928e1c7] { justify-content: space-between; } .footer-v-img[data-v-5928e1c7] { bottom: 0; justify-content: center; height: 70px; /* scrolling thumbnails on mobile */ overflow-x: auto; } .footer-v-img img[data-v-5928e1c7] { width: 60px; height: 60px; cursor: pointer; -webkit-transition: transform 0.2s ease-out; transition: transform 0.2s ease-out; object-fit: cover; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } .footer-v-img img.is-selected[data-v-5928e1c7] { transform: scale(1.1); } .footer-v-img img[data-v-5928e1c7]:not(:last-child) { margin-right: 7px; } .title-v-img[data-v-5928e1c7] { font-family: 'Avenir', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; color: white; text-align: center; max-height: 100%; overflow: auto; } .count-v-img[data-v-5928e1c7], .buttons-v-img[data-v-5928e1c7] { width: 80px; font-family: 'Avenir', Helvetica, Arial, sans-serif; } .count-v-img[data-v-5928e1c7] { font-size: 15px; color: white; margin-left: 10px; } .buttons-v-img[data-v-5928e1c7] { margin-right: 10px; text-align: right; } .buttons-v-img span path[data-v-5928e1c7] { fill: #e5e6eb; -webkit-transition: fill 0.4s ease-in-out; transition: fill 0.4s ease-in-out; } .buttons-v-img span[data-v-5928e1c7] { cursor: pointer; color: #e5e6eb; font-size: 30px; -webkit-transition: color 0.4s ease-in-out; transition: color 0.4s ease-in-out; text-decoration: none; text-align: center; } .buttons-v-img span[data-v-5928e1c7]:not(:last-child) { margin-right: 8px; } .buttons-v-img span svg[data-v-5928e1c7] { height: 20px; width: 15px; } .buttons-v-img span:hover svg path[data-v-5928e1c7] { fill: white; } .buttons-v-img span[data-v-5928e1c7]:hover { color: white; } .prev-v-img svg[data-v-5928e1c7], .next-v-img svg[data-v-5928e1c7] { margin: 5px auto; } .prev-v-img[data-v-5928e1c7], .next-v-img[data-v-5928e1c7] { color: white; width: 35px; height: 35px; position: absolute; top: 50%; margin-top: -12.5px; font-size: 15px; font-family: 'Avenir', Helvetica, Arial, sans-serif; text-align: center; background-color: rgba(0, 0, 0, 0.3); z-index: 1000; opacity: 0.3; -webkit-transition: opacity 0.3s ease-in-out; transition: opacity 0.3s ease-in-out; cursor: pointer; } .prev-v-img[data-v-5928e1c7]:hover, .next-v-img[data-v-5928e1c7]:hover { opacity: 1; } .prev-v-img[data-v-5928e1c7] { left: 10px; } .next-v-img[data-v-5928e1c7] { right: 10px; } .v-img-fade-enter[data-v-5928e1c7], .v-img-fade-leave-to[data-v-5928e1c7] { opacity: 0; } .v-img-fade-enter-active[data-v-5928e1c7], .v-img-fade-leave-active[data-v-5928e1c7] { -webkit-transition: opacity 0.3s ease-in-out; transition: opacity 0.3s ease-in-out; } ";t.type="text/css",t.styleSheet?t.styleSheet.cssText=n:t.appendChild(document.createTextNode(n)),e.appendChild(t)}}();var ImgScreen={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.closed?e._e():n("div",{staticClass:"fullscreen-v-img",on:{click:function(t){if(t.target!==t.currentTarget)return null;e.close(t)}}},[n("div",{staticClass:"header-v-img"},[n("span",{staticClass:"count-v-img"},[e.images.length>1?n("span",[e._v(e._s(e.currentImageIndex+1)+"/"+e._s(e.images.length)+" ")]):e._e()]),n("span",{staticClass:"title-v-img"},[e._v(e._s(e.titles[e.currentImageIndex]))]),n("div",{staticClass:"buttons-v-img"},[e.sourceButtons[e.currentImageIndex]?n("span",[n("a",{attrs:{href:e.images[e.currentImageIndex],target:"_blank"}},[n("svg",{staticStyle:{"enable-background":"new 0 0 475.078 475.077"},attrs:{xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",version:"1.1",id:"Capa_1",x:"0px",y:"0px",width:"512px",height:"512px",viewBox:"0 0 475.078 475.077","xml:space":"preserve"}},[n("path",{attrs:{d:"M467.083,318.627c-5.324-5.328-11.8-7.994-19.41-7.994H315.195l-38.828,38.827c-11.04,10.657-23.982,15.988-38.828,15.988    c-14.843,0-27.789-5.324-38.828-15.988l-38.543-38.827H27.408c-7.612,0-14.083,2.669-19.414,7.994    C2.664,323.955,0,330.427,0,338.044v91.358c0,7.614,2.664,14.085,7.994,19.414c5.33,5.328,11.801,7.99,19.414,7.99h420.266    c7.61,0,14.086-2.662,19.41-7.99c5.332-5.329,7.994-11.8,7.994-19.414v-91.358C475.078,330.427,472.416,323.955,467.083,318.627z     M360.025,414.841c-3.621,3.617-7.905,5.424-12.854,5.424s-9.227-1.807-12.847-5.424c-3.614-3.617-5.421-7.898-5.421-12.844    c0-4.948,1.807-9.236,5.421-12.847c3.62-3.62,7.898-5.431,12.847-5.431s9.232,1.811,12.854,5.431    c3.613,3.61,5.421,7.898,5.421,12.847C365.446,406.942,363.638,411.224,360.025,414.841z M433.109,414.841    c-3.614,3.617-7.898,5.424-12.848,5.424c-4.948,0-9.229-1.807-12.847-5.424c-3.613-3.617-5.42-7.898-5.42-12.844    c0-4.948,1.807-9.236,5.42-12.847c3.617-3.62,7.898-5.431,12.847-5.431c4.949,0,9.233,1.811,12.848,5.431    c3.617,3.61,5.427,7.898,5.427,12.847C438.536,406.942,436.729,411.224,433.109,414.841z",fill:"#FFFFFF"}}),n("path",{attrs:{d:"M224.692,323.479c3.428,3.613,7.71,5.421,12.847,5.421c5.141,0,9.418-1.808,12.847-5.421l127.907-127.908    c5.899-5.519,7.234-12.182,3.997-19.986c-3.23-7.421-8.847-11.132-16.844-11.136h-73.091V36.543c0-4.948-1.811-9.231-5.421-12.847    c-3.62-3.617-7.901-5.426-12.847-5.426h-73.096c-4.946,0-9.229,1.809-12.847,5.426c-3.615,3.616-5.424,7.898-5.424,12.847V164.45    h-73.089c-7.998,0-13.61,3.715-16.846,11.136c-3.234,7.801-1.903,14.467,3.999,19.986L224.692,323.479z",fill:"#FFFFFF"}})])])]):e._e(),n("span",{on:{click:e.close}},[e._v("×")])])]),n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.visibleUI&&1!==e.images.length?n("span",{staticClass:"prev-v-img",on:{click:e.prev}},[n("svg",{attrs:{width:"25",height:"25",viewBox:"0 0 1792 1915",xmlns:"http://www.w3.org/2000/svg"}},[n("path",{attrs:{d:"M1664 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z",fill:"#fff"}})])]):e._e()]),n("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.visibleUI&&1!==e.images.length?n("span",{staticClass:"next-v-img",on:{click:e.next}},[n("svg",{attrs:{width:"25",height:"25",viewBox:"0 0 1792 1915",xmlns:"http://www.w3.org/2000/svg"}},[n("path",{attrs:{d:"M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z",fill:"#fff"}})])]):e._e()]),e.thumbnails&&e.images.length>1?n("div",{staticClass:"footer-v-img"},e._l(e.images,function(t,i){return n("img",{key:i,class:{"is-selected":e.currentImageIndex==i},attrs:{src:t},on:{click:function(t){e.select(i)}}})})):e._e(),n("div",{staticClass:"content-v-img"},[n("img",{attrs:{src:e.images[e.currentImageIndex]},on:{click:e.next}})])],1)])},staticRenderFns:[],_scopeId:"data-v-5928e1c7",data:function(){return{images:[],titles:[],sourceButtons:[],visibleUI:!0,currentImageIndex:0,closed:!0,uiTimeout:null,handlers:{},thumbnails:!1}},watch:{closed:function(e){e&&this.handlers.closed&&this.handlers.closed(),!e&&this.handlers.opened&&this.handlers.opened()}},methods:{fireChangeEvent:function(){this.handlers.changed&&this.handlers.changed(this.currentImageIndex)},close:function(){this.closed||(document.querySelector("body").classList.remove("body-fs-v-img"),this.images=[],this.currentImageIndex=0,this.closed=!0)},next:function(){!this.closed&&this.images.length>1&&(this.currentImageIndex+1<this.images.length?this.currentImageIndex++:this.currentImageIndex=0,this.fireChangeEvent())},select:function(e){this.currentImageIndex=e},prev:function(){!this.closed&&this.images.length>1&&(this.currentImageIndex>0?this.currentImageIndex--:this.currentImageIndex=this.images.length-1,this.fireChangeEvent())},showUI:function(){var e=this;this.closed||(clearTimeout(this.uiTimeout),this.visibleUI=!0,this.uiTimeout=setTimeout(function(){e.visibleUI=!1},3500))}},created:function(){var e=this;window.addEventListener("keyup",function(t){27!==t.keyCode&&81!==t.keyCode||e.close(),39!==t.keyCode&&76!==t.keyCode||e.next(),37!==t.keyCode&&72!==t.keyCode||e.prev()}),window.addEventListener("scroll",function(){e.close()}),window.addEventListener("mousemove",function(){e.showUI()})}},babelHelpers={},asyncGenerator=function(){function e(e){this.value=e}function t(t){function n(a,s){try{var o=t[a](s),r=o.value;r instanceof e?Promise.resolve(r.value).then(function(e){n("next",e)},function(e){n("throw",e)}):i(o.done?"return":"normal",o.value)}catch(e){i("throw",e)}}function i(e,t){switch(e){case"return":a.resolve({value:t,done:!0});break;case"throw":a.reject(t);break;default:a.resolve({value:t,done:!1})}(a=a.next)?n(a.key,a.arg):s=null}var a,s;this._invoke=function(e,t){return new Promise(function(i,o){var r={key:e,arg:t,resolve:i,reject:o,next:null};s?s=s.next=r:(a=s=r,n(e,t))})},"function"!=typeof t.return&&(this.return=void 0)}return"function"==typeof Symbol&&Symbol.asyncIterator&&(t.prototype[Symbol.asyncIterator]=function(){return this}),t.prototype.next=function(e){return this._invoke("next",e)},t.prototype.throw=function(e){return this._invoke("throw",e)},t.prototype.return=function(e){return this._invoke("return",e)},{wrap:function(e){return function(){return new t(e.apply(this,arguments))}},await:function(t){return new e(t)}}}(),_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(e[i]=n[i])}return e},toConsumableArray=function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)},addPluginAttributes=function(e,t,n){var i="pointer",a=t.arg||null,s=void 0,o=void 0,r=e.src,c=void 0,l=void 0,u={};return n.altAsTitle&&(c=e.alt),s=n.openOn,o=n.sourceButton,l=n.thumbnails,void 0!==t.value&&(i=t.value.cursor||i,a=t.value.group||a,s=t.value.openOn||s,r=t.value.src||r,c=t.value.title||c,u.opened=t.value.opened,u.closed=t.value.closed,u.changed=t.value.changed,void 0!==t.value.sourceButton&&(o=t.value.sourceButton),void 0!==t.value.thumbnails&&(l=t.value.thumbnails)),e.setAttribute("data-vue-img-src",r),a&&e.setAttribute("data-vue-img-group",a),c&&e.setAttribute("data-vue-img-title",c),o&&e.setAttribute("data-vue-img-source-button",o),l&&e.setAttribute("data-vue-img-thumbnails",l),r||console.error("v-img element missing src parameter."),e.style.cursor=i,{cursor:i,src:r,group:a,title:c,events:u,sourceButton:o,openOn:s,thumbnails:l}},install=function(e,t){var n=e.extend(ImgScreen);t=_extends({altAsTitle:!1,sourceButton:!1,thumbnails:!1,openOn:"click"},t),e.directive("img",{update:function(e,n,i,a){var s=void 0,o=void 0;a.data.attrs&&i.data.attrs&&(o=a.data.attrs.src!==i.data.attrs.src,t.altAsTitle&&(s=a.data.attrs.alt!==i.data.attrs.alt));var r=n.oldValue!==n.value;(o||s||r)&&addPluginAttributes(e,n,t)},bind:function(i,a){var s=addPluginAttributes(i,a,t),o=window.vueImg;if(!o){var r=document.createElement("div");r.setAttribute("id","imageScreen"),document.querySelector("body").appendChild(r),o=window.vueImg=(new n).$mount("#imageScreen")}i.addEventListener(s.openOn,function(){var t=void 0;t=i.dataset.vueImgGroup?[].concat(toConsumableArray(document.querySelectorAll('img[data-vue-img-group="'+i.dataset.vueImgGroup+'"]'))):[i],e.set(o,"images",t.map(function(e){return e.dataset.vueImgSrc})),e.set(o,"titles",t.map(function(e){return e.dataset.vueImgTitle})),e.set(o,"sourceButtons",t.map(function(e){return"true"===e.dataset.vueImgSourceButton})),e.set(o,"thumbnails","true"===i.dataset.vueImgThumbnails),e.set(o,"currentImageIndex",t.indexOf(i)),e.set(o,"handlers",s.events),e.set(o,"closed",!1)})}})};"undefined"!=typeof window&&window.Vue&&window.Vue.use(install);/* harmony default export */ __webpack_exports__["a"] = (install);
//# sourceMappingURL=v-img.mjs.map


/***/ }),

/***/ "SGec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__ = __webpack_require__("CHQz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a3a092e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__ = __webpack_require__("KoCi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a3a092e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V55e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WYec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var store = {};

  return {
    has: function has(uri) {
      return !!store[uri];
    },
    get: function get(uri) {
      return JSON.parse(store[uri]);
    },
    set: function set(uri, data) {
      store[uri] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
    }
  };
})());

/***/ }),

/***/ "WwkJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Contact__ = __webpack_require__("FnhZ");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    name: 'feed',
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }, {
    path: '/by/:author',
    name: 'author',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }, {
    path: '/read/:post',
    name: 'post',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */]
  }, {
    path: '/contact',
    name: 'contact',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_3__components_Contact__["a" /* default */]
  }]
}));

/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Blog__ = __webpack_require__("SGec");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Blog__["a"]; });


/***/ }),

/***/ "bksL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  feed: function feed() {
    return {
      path: '/feed.json',
      resolve: function resolve(response, mappers) {
        return mappers.pipe(response.results);
      }
    };
  }
});

/***/ }),

/***/ "cX0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return scrollTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return kebabify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prettyDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation__ = __webpack_require__("M75F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation__);



var scrollTo = function scrollTo(pos) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_1_scrollto_with_animation___default()(document.documentElement, 'scrollTop', pos, duration, 'easeInOutSine', resolve);
    }, delay);
  });
};

var kebabify = function kebabify(words) {
  return words.toLowerCase().replace(' ', '-');
};

var prettyDate = function prettyDate(date) {
  return new Date(date).toString().split(' ').slice(0, 4).join(' ').replace(/( \d+)$/, ',$1');
};

/***/ }),

/***/ "cb2V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cache__ = __webpack_require__("WYec");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge__ = __webpack_require__("mB6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_merge__);





// install $resource as a Vue plugin
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, _ref) {
    var _ref$endpoint = _ref.endpoint,
        endpoint = _ref$endpoint === undefined ? '' : _ref$endpoint,
        _ref$resources = _ref.resources,
        resources = _ref$resources === undefined ? {} : _ref$resources;

    Vue.prototype.$getResource = function (method, options) {
      var _this = this;

      var name = this.$options.resource;
      if (!name || !resources[name] || !resources[name][method]) return;

      // get fetch path and response resolver/mapper

      var _resources$name$metho = resources[name][method](options),
          path = _resources$name$metho.path,
          resolve = _resources$name$metho.resolve;

      var uri = endpoint + path;

      // methods return promise to allow chaining
      var mappers = {
        // only return promise without modifying instance $data
        pipe: function pipe(dataSet) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(dataSet);
        },

        // deep merge object with instance $data
        merge: function merge(dataSet) {
          __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default()(_this.$data, dataSet);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(dataSet);
        },

        // set individual props on instance $data
        set: function set(dataSet) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dataSet).forEach(function (prop) {
            _this.$set(_this.$data, prop, dataSet[prop]);
          });

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(dataSet);
        }

        // check to see if the resource has been cached already
      };if (__WEBPACK_IMPORTED_MODULE_2__cache__["a" /* default */].has(uri)) return resolve(__WEBPACK_IMPORTED_MODULE_2__cache__["a" /* default */].get(uri), mappers);

      // fetch, parse and cache resource then pass to resolver
      return fetch(uri).then(function (response) {
        return response.json();
      }).then(function (response) {
        return __WEBPACK_IMPORTED_MODULE_2__cache__["a" /* default */].set(uri, response);
      }).then(function (response) {
        return resolve(response, mappers);
      });
    };
  }
});

/***/ }),

/***/ "eJ85":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  blog: function blog() {
    return {
      path: '/blog.json',
      resolve: function resolve(response, mappers) {
        var blog = response.results[0];
        return mappers.merge({
          title: blog.title,
          labels: {
            post: blog.post_label,
            author: blog.author_label
          }
        });
      }
    };
  }
});

/***/ }),

/***/ "ggVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-nav',
  props: {
    navs: Number,
    content: Object,
    filters: {
      type: Object,
      default: function _default() {}
    }
  },

  computed: {
    labels: function labels() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).map(function (filter) {
        return _this.content.labels[filter];
      });
    }
  },

  methods: {
    show: function show() {
      window.rr = this.$router;
      return this.$router.currentRoute.path === '/';
    },
    navBack: function navBack() {
      if (this.navs && !this.filters.author) this.$router.go(-1);else this.$router.push('/');
    },
    navContact: function navContact() {
      this.$router.push('/contact');
    }
  }
});

/***/ }),

/***/ "is/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pace_progress__ = __webpack_require__("heTW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pace_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pace_progress__);


// pace progress bar
__WEBPACK_IMPORTED_MODULE_0_pace_progress___default.a.start();

// use pace hook to know when rendering is ready
__WEBPACK_IMPORTED_MODULE_0_pace_progress___default.a.once('hide', function () {
  window.prerenderReady = true;
});

// Spektrum Media console message
console.info('%c', 'line-height:48px;padding:18px 150px;background:url(\'https://s3-us-west-2.amazonaws.com/s.cdpn.io/450744/vue-snip.svg\') center / contain no-repeat;');

/***/ }),

/***/ "mCK5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qDh5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav"},[_c('div',{staticClass:"col-sm-4"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/static/logo.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:" col-sm-4"},[(false)?_c('h1',{staticClass:"nav__subtitle"},[_c('router-link',{staticClass:"post__author",attrs:{"to":'/gallery'}},[_c('span',[_vm._v("Galerie")])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:" col-sm-4"},[(false)?_c('h1',[_vm._v("/")]):_vm._e()]),_vm._v(" "),(false)?_c('h1',{staticClass:"nav__subtitle"},[_c('router-link',{staticClass:"post__author",attrs:{"to":'/contact'}},[_vm._v("Activités")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:" col-sm-4"},[(_vm.show())?_c('h1',{staticClass:"nav__subtitle"},[_c('router-link',{staticClass:"post__author",attrs:{"to":'/contact'}},[_vm._v("Contact")])],1):_vm._e()])])]),_vm._v(" "),_c('transition-group',{staticClass:"nav__menu",attrs:{"tag":"menu","name":"nav__item"}},_vm._l((_vm.labels),function(label){return _c('li',{key:label,staticClass:"nav__item",on:{"click":_vm.navBack}},[_c('i',{staticClass:"nav__item--icon"}),_vm._v(" "),_c('span',{staticClass:"nav__item--label"},[_vm._v(_vm._s(label))])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rcwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/* harmony default export */ __webpack_exports__["a"] = ({
  post: function post(id) {
    return {
      path: "/post/" + id + ".json",
      resolve: function resolve(response, mappers) {
        var _response$results$ = response.results[0],
            title = _response$results$.title,
            content = _response$results$.content,
            meta = _response$results$.meta;
        //    content = '<p>' + content.split('\n\n').join('</p><p>') + '</p>'

        return mappers.merge(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ title: title, content: content }, meta));
      }
    };
  }
});

/***/ }),

/***/ "uJQI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_media__ = __webpack_require__("MdQY");



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, queries) {
    var DeviceVM = new Vue({
      data: function data() {
        return {
          devices: {}
        };
      },


      methods: {
        addDevice: function addDevice(name, active) {
          var _this = this;

          this.$set(this.devices, name, active);

          return function (_ref) {
            var matches = _ref.matches;

            _this.devices[name] = matches;
          };
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(queries).forEach(function (name) {
      var query = Object(__WEBPACK_IMPORTED_MODULE_1__match_media__["a" /* default */])('(' + queries[name] + ')');
      var update = DeviceVM.addDevice(name, query.matches);
      query.addListener(update);
    });

    Vue.prototype.$device = DeviceVM.devices;
  }
});

/***/ }),

/***/ "vTyi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"blog",class:{ 'blog--reading': this.post }},[_c('blog-nav',{attrs:{"content":_vm.content,"filters":_vm.filters,"navs":_vm.navs}}),_vm._v(" "),_c('contact-form',{attrs:{"filters":_vm.filters}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wCbp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__ = __webpack_require__("MfHO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41631d04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__ = __webpack_require__("wn6v");
function injectStyle (ssrContext) {
  __webpack_require__("GXXQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41631d04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wn6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{key:"id",staticClass:"contact-form",attrs:{"id":"contact-form"}},[_c('hr',{key:"id0",attrs:{"size":"20"}}),_vm._v(" "),_c('h1',{key:"id1",staticClass:"contact-form_title"},[_vm._v("Contactez-nous : "),_c('a',{attrs:{"href":"mailto::ccmartigny@gmail.com"}},[_c('font',{attrs:{"color":"blue"}},[_vm._v("ccmartigny@gmail.com")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({ name: 'app' });

/***/ }),

/***/ "xdpD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFeed_vue__ = __webpack_require__("2x06");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00875075_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFeed_vue__ = __webpack_require__("Ey2R");
function injectStyle (ssrContext) {
  __webpack_require__("mCK5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00875075"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogFeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00875075_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogFeed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y7Eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogNav_vue__ = __webpack_require__("ggVv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b61dd80e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogNav_vue__ = __webpack_require__("qDh5");
function injectStyle (ssrContext) {
  __webpack_require__("V55e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b61dd80e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.769b2e26f221163df90d.js